const FinishIcon = (props) => {
  const { color = 'currentColor' } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 20 20"
      fill="none"
    >
      <mask
        id="mask0_2_986"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_2_986)">
        <path
          d="M2.66522 17.2067L6.21481 7.17L12.7227 13.6571L2.66522 17.2067ZM4.43439 15.4375L10.7261 13.2083L6.66356 9.14583L4.43439 15.4375ZM11.444 10.2531L10.9119 9.72125L15.399 5.21312C15.7612 4.85104 16.2006 4.67 16.7171 4.67C17.2336 4.67 17.6799 4.85104 18.0561 5.21312L18.689 5.82542L18.1731 6.37813L17.5608 5.74521C17.3343 5.51868 17.0627 5.40542 16.7461 5.40542C16.4292 5.40542 16.1576 5.51868 15.9311 5.74521L11.444 10.2531ZM8.87814 7.70833L8.34626 7.17625L9.0546 6.46792C9.30238 6.22014 9.42626 5.9234 9.42626 5.57771C9.42626 5.23215 9.30238 4.93542 9.0546 4.6875L8.3621 3.97438L8.89418 3.44229L9.58647 4.13458C9.96147 4.53736 10.149 5.01493 10.149 5.56729C10.149 6.11965 9.96147 6.59722 9.58647 7L8.87814 7.70833ZM10.1715 8.98083L9.61856 8.44875L12.0017 6.06583C12.2281 5.83931 12.3413 5.57111 12.3413 5.26125C12.3413 4.95139 12.2281 4.68319 12.0017 4.45667L10.6811 3.15708L11.2131 2.625L12.5336 3.94563C12.9151 4.32701 13.1058 4.77597 13.1058 5.2925C13.1058 5.80903 12.9151 6.25104 12.5336 6.61854L10.1715 8.98083ZM12.6954 11.5256L12.1633 10.9935L13.5977 9.55938C14.0058 9.17896 14.4895 8.98528 15.0488 8.97833C15.6081 8.97139 16.0849 9.16507 16.4792 9.55938L17.5592 10.6394L17.0271 11.1715L15.9471 10.0915C15.6939 9.83813 15.391 9.71146 15.0383 9.71146C14.6858 9.71146 14.383 9.83813 14.1298 10.0915L12.6954 11.5256Z"
          fill={color}
        />
      </g>
    </svg>
  );
};

export default FinishIcon;
